/**
 * User Configuration
 *
 * Edit ONLY this file to customize the portfolio with your information.
 * Everything a user needs to personalize is here.
 */

export const siteConfig = {
  // ============================================================================
  // SITE & DOMAIN
  // ============================================================================
  site: {
    baseUrl: "https://amitdhoju.com.np",
    name: "Amit Dhoju Portfolio",
  },

  // ============================================================================
  // USER INFORMATION
  // ============================================================================
  user: {
    name: "Amit Dhoju",
    email: "amitdhoju@gmail.com",
    phone: "+9779841110194",
    title: "JavaScript Software Engineer | Full Stack Developer",
    location: {
      city: "Bhaktapur",
      country: "Nepal",
      countryCode: "NP",
    },
    bio: "Full Stack JavaScript Software Engineer with 6+ years of experience building scalable web applications using Node.js, React, Vue.js, Next.js, and TypeScript.",
    social: {
      github: "https://github.com/Amit091",
      linkedin: "https://www.linkedin.com/in/amitdhoju/",
    },
    languages: ["English", "Nepali"],
    education: {
      school: "Kantipur Engineering College",
      degree: "Bachelor in Computer Engineering",
      city: "Lalitpur",
    },
    resume: {
      fileName: "Amit_Dhoju_resume.pdf",
    },
  },

  // ============================================================================
  // SEO & KEYWORDS
  // ============================================================================
  seo: {
    keywords: [
      "Amit Dhoju",
      "Full Stack Developer",
      "JavaScript Engineer",
      "Node.js Developer",
      "React Developer",
      "Next.js Developer",
      "Vue.js Developer",
      "TypeScript",
      "Nepal Software Engineer",
      "Remote Full Stack Developer",
      "Freelance JavaScript Developer Nepal",
      "AWS Serverless Developer",
      "Software Engineer Bhaktapur",
    ],
    description:
      "Full Stack JavaScript Software Engineer in Nepal with 6+ years building scalable web apps with Node.js, React, Next.js, TypeScript & AWS. Open to remote work.",
    jobTitle: "Full Stack JavaScript Software Engineer",
    // Topics used in Person structured data (knowsAbout)
    knowsAbout: [
      "JavaScript",
      "TypeScript",
      "Node.js",
      "React",
      "Next.js",
      "Vue.js",
      "Nest.js",
      "Express.js",
      "GraphQL",
      "REST APIs",
      "PostgreSQL",
      "MySQL",
      "Redis",
      "Amazon Web Services",
      "AWS Lambda",
      "Serverless Architecture",
      "Docker",
      "CI/CD",
      "GitHub Actions",
      "OpenSearch",
      "Tailwind CSS",
      "shadcn/ui",
      "Progressive Web Apps",
      "Role-Based Access Control",
      "Full Stack Web Development",
    ],
  },

  // ============================================================================
  // GOOGLE VERIFICATION
  // ============================================================================
  googleSiteVerification: "El9pBB_2meVr8SB2Mxdd1fCAr47OzJ7hn1R5Oe1Ja74",
}

// Convenience exports
export const SITE_URL = siteConfig.site.baseUrl
export const USER_NAME = siteConfig.user.name
export const USER_EMAIL = siteConfig.user.email
export const USER_TITLE = siteConfig.user.title
